import {Application} from '../../../portaljs/constants/application';

export const MLMarketingURL = {
  DRAWINGS: 'https://www.masterlibrary.com/products-modules/ml-drawings',
  SCHEDULES: 'https://www.masterlibrary.com/products-modules/ml-schedules',
  WORKORDERS: 'https://www.masterlibrary.com/products-modules/ml-work-orders',
  HELPDESK: 'https://www.masterlibrary.com/products-modules/ml-work-orders',
  ITAM: 'https://follettsoftware.com/technology-suite/it-asset-manager'
} as const;

export class MLMarketingURLUtils {
  public static getMarketingURL(app: Application) {
    switch (app) {
      case Application.MASTERLIBRARY_DRAWINGS:
        return MLMarketingURL.DRAWINGS;
      case Application.MASTERLIBRARY_SCHEDULES:
        return MLMarketingURL.SCHEDULES;
      case Application.MASTERLIBRARY_WORKORDERS:
        return MLMarketingURL.WORKORDERS;
      case Application.MASTERLIBRARY_HELPDESK:
        return MLMarketingURL.HELPDESK;
      case Application.MASTERLIBRARY_ITAM:
        return MLMarketingURL.ITAM;

      default:
        return undefined;

    }
  }

  public static convertIfMLMarketingURL(url: string): string {
    if(url === undefined) {
      return undefined;
    } else {
      if(url.indexOf(MLMarketingURL.WORKORDERS) === 0) {
        return MLMarketingURL.WORKORDERS;
      } else if(url.indexOf(MLMarketingURL.SCHEDULES) === 0) {
        return MLMarketingURL.SCHEDULES;
      } else if(url.indexOf(MLMarketingURL.DRAWINGS) === 0) {
        return MLMarketingURL.DRAWINGS;
      } else if(url.indexOf(MLMarketingURL.HELPDESK) === 0) {
        return MLMarketingURL.HELPDESK;
      } else if(url.indexOf(MLMarketingURL.ITAM) === 0) {
        return MLMarketingURL.ITAM;
      } else {
        return url;
      }
    }
  }
}
